import React from "react";
import { IMaskInput } from "react-imask";

// TODO combine this with ThousandsNumberInputFloat
// these are only separate because its hard or impossible to pass props from NumberFieldConfigured to the inputComponent
// to tell it whether to display decimal points or not

export const ThousandsNumberInput = React.forwardRef(function ThousandsNumberInput(props, ref) {
  const { onChange, name, numberType, ...other }: any = props;
  return (
    <IMaskInput
      {...other}
      mask={Number}
      scale={0}
      unmask
      thousandsSeparator={"."}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: name, value } })}
    />
  );
});
